var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import JSZip from 'jszip';
import { renderCover } from './renderCover';
import { renderImageCover } from './renderImage';
function padIndex(index) {
    return String(index).padStart(2, '0');
}
export function createInstagramZip(data, selectedImages) {
    return __awaiter(this, void 0, Promise, function () {
        var zip, fileIndex, coverBlob, i, image, slideBlob, ctaBlob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    zip = new JSZip();
                    fileIndex = 1;
                    return [4 /*yield*/, renderCover(data)];
                case 1:
                    coverBlob = _a.sent();
                    zip.file("".concat(padIndex(fileIndex), "-cover.png"), coverBlob);
                    fileIndex += 1;
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < selectedImages.length)) return [3 /*break*/, 5];
                    image = selectedImages[i];
                    return [4 /*yield*/, renderImageCover(image.url)];
                case 3:
                    slideBlob = _a.sent();
                    zip.file("".concat(padIndex(fileIndex), "-slide-").concat(padIndex(i + 1), ".png"), slideBlob);
                    fileIndex += 1;
                    _a.label = 4;
                case 4:
                    i += 1;
                    return [3 /*break*/, 2];
                case 5:
                    if (!data.ctaUrl) return [3 /*break*/, 7];
                    return [4 /*yield*/, renderImageCover(data.ctaUrl)];
                case 6:
                    ctaBlob = _a.sent();
                    zip.file("".concat(padIndex(fileIndex), "-cta.png"), ctaBlob);
                    _a.label = 7;
                case 7: return [2 /*return*/, zip.generateAsync({ type: 'blob' })];
            }
        });
    });
}
export function downloadBlob(blob, filename) {
    var url = URL.createObjectURL(blob);
    var anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(function () { return URL.revokeObjectURL(url); }, 0);
}
